var _rect, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableTopRightDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "#494949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1516 -3154C-1516 -3155.1 -1515.1 -3156 -1514 -3156H3279C3280.1 -3156 3281 -3155.1 3281 -3154V1709C3281 1710.1 3280.1 1711 3279 1711H-1514C-1515.1 1711 -1516 1710.1 -1516 1709V-3154Z",
    fill: "#404040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4041_4554)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2336,
    transform: "translate(-460 -1374)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4041_4554)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -223.5,
    y: -8,
    width: 256,
    height: 128,
    rx: 12,
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.5 2H5.5C4.70508 2.00237 3.9434 2.31921 3.3813 2.8813C2.81921 3.4434 2.50237 4.20508 2.5 5V13.86L6.38 9.98C6.9517 9.43586 7.71074 9.13238 8.5 9.13238C9.28926 9.13238 10.0483 9.43586 10.62 9.98L13.491 12.867L14.379 11.979C14.9426 11.4185 15.7052 11.1039 16.5 11.1039C17.2948 11.1039 18.0574 11.4185 18.621 11.979L22.5 15.86V5C22.4976 4.20508 22.1808 3.4434 21.6187 2.8813C21.0566 2.31921 20.2949 2.00237 19.5 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.62 9.97994C10.0483 9.4358 9.28926 9.13232 8.5 9.13232C7.71074 9.13232 6.9517 9.4358 6.38 9.97994L2.5 13.8599V18.9999C2.50237 19.7949 2.81921 20.5565 3.3813 21.1186C3.9434 21.6807 4.70508 21.9976 5.5 21.9999H19.5C19.9034 21.9997 20.3026 21.9181 20.6737 21.76C21.0449 21.6019 21.3803 21.3706 21.66 21.0799L10.62 9.97994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M22.5012 15.8581L18.6222 11.9791C18.0586 11.4186 17.296 11.104 16.5012 11.104C15.7063 11.104 14.9438 11.4186 14.3802 11.9791L13.4922 12.8671L21.6572 21.0761C22.1992 20.5211 22.5022 19.7761 22.5012 19.0001V15.8581Z",
    fill: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1514 -3155H3279V-3157H-1514V-3155ZM3280 -3154V1709H3282V-3154H3280ZM3279 1710H-1514V1712H3279V1710ZM-1515 1709V-3154H-1517V1709H-1515ZM-1514 1710C-1514.55 1710 -1515 1709.55 -1515 1709H-1517C-1517 1710.66 -1515.66 1712 -1514 1712V1710ZM3280 1709C3280 1709.55 3279.55 1710 3279 1710V1712C3280.66 1712 3282 1710.66 3282 1709H3280ZM3279 -3155C3279.55 -3155 3280 -3154.55 3280 -3154H3282C3282 -3155.66 3280.66 -3157 3279 -3157V-3155ZM-1514 -3157C-1515.66 -3157 -1517 -3155.66 -1517 -3154H-1515C-1515 -3154.55 -1514.55 -3155 -1514 -3155V-3157Z",
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4041_4554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2336,
    fill: "white",
    transform: "translate(-460 -1374)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4041_4554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1042,
    height: 1350,
    fill: "white",
    transform: "translate(-281 -814)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTopRightDefaultIcon);
export default __webpack_public_path__ + "static/media/table-top-right-default-icon.4d9f4d13666e26e93dd20a1e410cff20.svg";
export { ForwardRef as ReactComponent };